import React, { Component } from 'react';
import { connect } from "react-redux";
import { Loading } from '../../../common/loading';
import DragDropUpload from '../../../common/upload/drag-drop-upload/drag-drop-upload.component';
import { DOWNLOAD_TEMPLATE_lABEL, EXTRACT_TEMPLATE_MODULES, FILE_NAME_TEMPLATE, HR_UPLOAD_FILE_LIMITATIONS, HR_UPLOAD_TYPES, HR_UPLOAD_TYPE_MESSAGE, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, MODAL_CUSTOM_TITLE, UPLOAD_TYPES } from "../../../../constants/external-constants";
import { Button } from 'react-bootstrap';
import { NotificationModal } from '../../../common/modal/notification-modal.component';
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import DetailContainer from '../../../common/Layout/details/DetailsLayout.component';
import { RequestHeaders } from '../../../common/header-logo/request-header.component';
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { HrUploadTypeAction } from '../../../../store/external/manage-user/hr-upload/hr-upload.reducer';
import { bindActionCreators } from "@reduxjs/toolkit";
import { SelectFieldFloatingLabel } from '../../../common/custom-form/select-filter.component';
import Translation from '../../../common/translation/translation.component';

class HRUpload extends Component {
    constructor(props) {
        super(props);
        this.childRef = React.createRef();
        this.state = {
            uploadedFiles:[],
            allowedFiles:[], 
            maxFiles:0,
            showNotif: false,
            isLoading:true,
            filterLoading:false,
            loadingLabel: "",
            uploadInProgress: false,
            extractAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message
        }
    }

    async componentDidMount() {
        const { getHrUploadTypes, resetHrUploadForm } = this.props;

        await resetHrUploadForm();
        await getHrUploadTypes().then(() => { this.setState({ isLoading: false }) });
    }
    toLocaleLanguage = (key) => {
          const { locale } = this.props.translation;
          if (locale === null || locale === '' || locale === undefined)
              return translation[translation['defaultLocaleLanguage']][key];
  
          return translation[locale][key];
    }

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    handleDownloadTemplate = () => {
        const { downloadHrUploadTemplate } = this.props;
        this.setState({
            filterLoading: true,
            loadingLabel: "Downloading"
        })
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            downloadHrUploadTemplate(EXTRACT_TEMPLATE_MODULES.hrUploadTemplate, FILE_NAME_TEMPLATE.hrUploadTemplate).then(() => {
                this.setState({
                    filterLoading: false,
                    loadingLabel: ""
                })
            });;
        } else {
            this.setState({
                filterLoading: false,
                loadingLabel: ""
            })
        }
    }

    handleSuccessProcess = (data) => {
        const { postExecuteProcess, resetHrUploadForm } = this.props;
        postExecuteProcess(data.UploadId);
        this.setState({
            uploadInProgress: false
        });

        resetHrUploadForm();
    }

    handleAddFiles = () => {
        this.forceUpdate();
    }

    handleRemoveFiles = () => {
        this.forceUpdate();
    }

    onErrorUpload = () => {
        this.setState({
            uploadInProgress: false
        })
    }

    handleUpload = () => {
        if (this.childRef.current) {
            this.childRef.current.processQueue();
        }
        this.setState({
            uploadInProgress: true
        });
    }

    disabledUpload = () => {
        const { hrUploadForm } = this.props;
        const intialField = !(!hrUploadForm.hrUploadTypeId);

        let validFiles = false;
        if (this.childRef.current) {
            validFiles = this.childRef.current.checkValidFileForm();
        }

        return !(intialField && validFiles);
    }

    dropDragDisable = () => {
        const { hrUploadForm } = this.props;
        const requiredField = !hrUploadForm.hrUploadTypeId

        return requiredField;
    }


    djsConfigParams = () => {
        const { hrUploadForm } = this.props;

        var baseParams = {
            HrUploadTypeId: hrUploadForm.hrUploadTypeId
        };

        var djsConfig = {
            params: {
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
                UploadTypeId: UPLOAD_TYPES.HrUpload,
                ChargeTypeDetails: JSON.stringify({
                    ...baseParams,
                }),
            },
            maxFiles: HR_UPLOAD_FILE_LIMITATIONS.maxFiles,
            minFiles: HR_UPLOAD_FILE_LIMITATIONS.minFiles,
            acceptedFiles: HR_UPLOAD_FILE_LIMITATIONS.acceptedFiles,
            dictInvalidFileType: this.toLocaleLanguage('error_invalid_file_type'),
            dictMaxFilesExceeded: this.toLocaleLanguage('error_exceeded_maximum_file'),
            dictErrorOccured: this.toLocaleLanguage('error_occured_reupload_file')
        };

        return djsConfig;
    }


    render() {
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdHRUploadRW])
        const { hrUploadForm, onHrUploadTypeSelect } = this.props;
        const { hrUploadTypeOptions } = this.props.hrUpload;
        return (
            <div className="invoice-wrapper-container inventory-report-component">
                <RequestHeaders headerTitle={"HRUpload"} />
                <div className="request-table data-table fit-width upload-form__wrapper">
                    <DetailContainer>
                        <div className="invoice-upload">
                            {
                                this.state.filterLoading &&
                                <Loading customClass="filter-loading" label={this.state.loadingLabel} />
                            }
                            <div className="invoice-cont-wrapper">
                                <div className="items-container">
                                    <div className="items-list">
                                        <Translation
                                            getOnlyText={true}
                                            onChangeTranslation={this.onChangeExtractAlertMsg}
                                            translationKey={"export_alert_message"} />

                                        <SelectFieldFloatingLabel
                                            className="form-select required"
                                            label={`${this.toLocaleLanguage('upload_type')}`}
                                            options={hrUploadTypeOptions}
                                            value={hrUploadForm.hrUploadTypeId ?? ""}
                                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            isError={false}
                                            fieldProp='hrUploadForm.hrUploadTypeId'
                                            onChangeAction={onHrUploadTypeSelect}
                                            optionLabelKey={{
                                                Key: "Key",
                                                Value: "Value"
                                            }}
                                        />

                                        {hrUploadForm.hrUploadTypeId === HR_UPLOAD_TYPES.Bulk ?
                                            <span className="pending-upload-message">{HR_UPLOAD_TYPE_MESSAGE.Bulk}</span> : null
                                        }

                                        {hrUploadForm.hrUploadTypeId === HR_UPLOAD_TYPES.Add ?
                                            <span className="pending-upload-message">{HR_UPLOAD_TYPE_MESSAGE.Add}</span> : null
                                        }

                                        {hrUploadForm.hrUploadTypeId === HR_UPLOAD_TYPES.Update ?
                                            <span className="pending-upload-message">{HR_UPLOAD_TYPE_MESSAGE.Update}</span> : null
                                        }
                                    </div>
                                    <DragDropUpload
                                        ref={this.childRef}
                                        buttonLabel={DOWNLOAD_TEMPLATE_lABEL.hr_upload}
                                        disabled={!isReadAndWrite == false ? this.dropDragDisable() : true}
                                        downloadButton={this.handleDownloadTemplate}
                                        djsConfigParams={this.djsConfigParams()}
                                        onSuccessProcess={this.handleSuccessProcess}
                                        onAddFiles={this.handleAddFiles}
                                        onRemoveFiles={this.handleRemoveFiles}
                                        onErrorUpload={this.onErrorUpload}
                                        uploadTypeId={UPLOAD_TYPES.HrUpload}
                                    />
                                </div>
                                <div className="upload-btn-section">
                                    <div className="save-btn-container">
                                        <Button disabled={!isReadAndWrite == false ? (this.disabledUpload() || this.state.uploadInProgress) : true} onClick={this.handleUpload} className="save-details-btn">Upload</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DetailContainer>
                </div>
            </div>
          
		)
    }
}


export default connect(
    state=>{
        const {
            translation
            , hrUpload
        }=state;

        const { hrUploadForm } = state.form;

        return {
            translation
            , hrUpload
            , hrUploadForm
        }
    },
    dispatch => bindActionCreators(
        Object.assign({}, HrUploadTypeAction),
        dispatch
   )
)(HRUpload);